<template>
  <b-row v-if="carregado">
    <b-col
      v-for="(proposta, $index) in statusProposta"
      :key="$index"
      cols="2"
    >
      <div class="shadow-box">
        <div style="text-align: center;padding-top: 0.5rem;">
          <div>
            <strong>{{ proposta.statusProposta }}</strong>
          </div>
          <div style="margin-top: 0.3rem">
            <span>{{ proposta.numeroPropostas }}</span>
          </div>
        </div>
        <dashboard-totalizador
          :valor="[proposta.porcentagemPropostas]"
          :cores="[proposta.color]"
        />
        <div
          style="text-align: center;"
        >
          <span><b>{{ proposta.valorTotalPropostas | converteValor }}</b></span>
        </div>
        <div
          class="
          cor-fundo"
          :style="`background-color: ${proposta.color} !important;`"
        />
      </div>
    </b-col>
  </b-row>
</template>

<style lang="scss">
.cor-fundo {
  margin-top: 0.5rem;
  height: 7px;
  border-bottom-right-radius: 0.428rem;
  border-bottom-left-radius: 0.428rem;
}

.shadow-box {
  box-shadow: 1px 2px 5px 4px rgb(20 20 20 / 40%);
  border-radius: 0.428rem;

  strong, span, b {
    color: var(--chart-text-color);
  }
}

.container-class {
  width: 100%;
  display: table-cell;
  padding-left: 0.5rem;
}
</style>

<script>
import api from '@/app-modulo/comercial/dashboard-comercial/shared/services/api'

export default {
  name: 'TotalizadorComercial',
  components: {
    dashboardTotalizador: () => import('@/shared/components/grafico-totalizador/GraficoTotalizador.vue'),
  },
  data() {
    return {
      statusProposta: null,
      carregado: false,
    }
  },
  created() {
    this.carregarDados()
  },
  methods: {
    carregarDados() {
      api.getTotalPropostas()
        .then(payload => {
          this.statusProposta = payload.data
          this.carregado = true
        })
    },
  },
}
</script>
